import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

// Eagerly load the home page (critical path)
import Home from "../pages/home";

// Lazy load all other pages - they'll be fetched only when navigated to
const Booking = lazy(() => import("../pages/booking/booking"));
const Cars = lazy(() => import("../pages/booking/cars"));
const CarsList = lazy(() => import("../pages/booking/carslist"));
const CarDetails = lazy(() => import("../pages/booking/carDetails"));
const RentalForm = lazy(() => import("../pages/booking/rentalForm"));
const Extras = lazy(() => import("../pages/booking/extras"));
const ThankYou = lazy(() => import("../pages/booking/thankYou"));
const Services = lazy(() => import("../pages/services"));
const AboutUs = lazy(() => import("../pages/aboutUs"));
const ContactUs = lazy(() => import("../pages/contactUs"));
const Payment = lazy(() => import("../pages/booking/payment"));
const TermsCondition = lazy(() => import("../pages/terms"));
const PrivacyPolicy = lazy(() => import("../pages/privacy"));
const Blog = lazy(() => import("../pages/blog/index"));
const BlogDetail = lazy(() => import("../pages/blog/blogDetail"));
const BlogCategory = lazy(() => import("../pages/blog/blogCategory"));
const BlogTag = lazy(() => import("../pages/blog/blogTag"));
const BlogSearch = lazy(() => import("../pages/blog/blogSearch"));

const AppRoutes = () => {
  // Don't handle sitemap.xml or robots.txt routes in React Router
  const currentPath = window.location.pathname;
  if (currentPath === '/sitemap.xml' || currentPath === '/robots.txt') {
    return null;
  }

  // Loading fallback for lazy-loaded pages
  const PageLoader = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff', zIndex: 9999 }}>
      <img src="/loader.gif" alt="Loading..." style={{ width: '120px', height: '120px' }} />
    </div>
  );

  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/cars" element={<Cars />} />
        <Route path="/carslist" element={<CarsList />} />
        <Route path="/car-details" element={<CarDetails />} />
        <Route path="/rental-form" element={<RentalForm />} />
        <Route path="/extras" element={<Extras />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/truck-utes" element={<Cars />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/terms-conditions" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/search" element={<BlogSearch />} />
        <Route path="/blog/category/:categorySlug" element={<BlogCategory />} />
        <Route path="/blog/tag/:tag" element={<BlogTag />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
